import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";

import { logoutUser } from "../../../redux/slices/userSlice";

import Icon from "../../Icon/Icon";
import AcronymIcon from "../AcronymIcon/AcronymIcon";
import { ChevronDownIcon } from "../../Icon/icons";
import "./Header.css";

function Header() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userSlice);

  const location = useLocation();

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <header>
      <Navbar collapseOnSelect expand="lg" variant="dark" className="bg-gradient">
        <Container>
          <Navbar.Brand href="/">
            <img src="/union_icon.svg" className="navbar-logo" alt="logo" /> Watchson
          </Navbar.Brand>
          <Navbar>
            <Nav className="ms-auto" activeKey={location.pathname}>
              {user.is_admin ? (
                <>
                  <Nav.Link href="/collaborators">Colaboradores</Nav.Link>
                  <Nav.Link href="/projects">Projetos</Nav.Link>
                </>
              ) : (
                <Nav.Link href="/collaborator">Colaborador</Nav.Link>
              )}
              <Nav.Link href="/help" disabled={true}>
                Ajuda
              </Nav.Link>

              <NavDropdown
                title={
                  <>
                    <AcronymIcon name={user.name} width="35px" height="35px" borderColor="#fff" />
                    <Icon style={{ margin: "0 10px" }}>
                      <ChevronDownIcon fill="#fff" />
                    </Icon>
                  </>
                }
              >
                <NavDropdown.ItemText>{user.email}</NavDropdown.ItemText>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.1" disabled={true}>
                  Ver Perfil
                </NavDropdown.Item>
                {user.is_admin && <NavDropdown.Item href="/mcp-keys">Gerar chave MCP</NavDropdown.Item>}
                <NavDropdown.Item href="/password-change">Redefinir Senha</NavDropdown.Item>
                <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
